import UserAvatar from '@/common/components/UserAvatars/UserAvatar';
import { Box, Group, Stack, Text } from '@mantine/core';
import React from 'react';
import { useTodoDrawerStore } from '@/stores/todoDrawerStore';
import { Note } from '@/common/types/databaseTypes';
import NoteListItem from '@/features/note/components/NoteListItem';
import { Trans, useTranslation } from 'react-i18next';
import { createDeletedUser, UserBase } from '@tickitacka/shared';

export interface Activity {
    user: UserBase | null;
    time: string;
    note?: Note;
}

export type ActivityItemProps = Activity;

export const ActivityItem: React.FC<ActivityItemProps> = ({
    user,
    time,
    note,
}) => {
    const { isDrawerOpen, closeDrawer } = useTodoDrawerStore();
    const { t } = useTranslation('common');

    const safeUser = user ?? createDeletedUser(t);
    console.log(safeUser);

    return (
        <Stack gap={4} px="sm" pb="xs">
            <Group gap={2}>
                <UserAvatar
                    name={safeUser.name}
                    size={12}
                    imageUrl={safeUser.profile_image_url}
                />
                <Trans
                    i18nKey="activity:actor"
                    components={[
                        <Text component="div" size="sm" fw={600} key="bold" />,
                        <Text component="div" size="sm" key="light" />,
                    ]}
                    values={{
                        name: safeUser.name,
                    }}
                />
                <Trans
                    i18nKey="activity:note.create"
                    components={[
                        <Text component="span" size="sm" fw={600} key="bold" />,
                        <Text component="span" size="sm" key="light" />,
                    ]}
                />
                <Text span size="xs" c="dimmed" pl={2}>
                    {time}
                </Text>
            </Group>
            {note && (
                <Box ml={16}>
                    <NoteListItem
                        noteId={note.id}
                        noteTitle={note.title}
                        onClick={() => {
                            if (isDrawerOpen) {
                                closeDrawer();
                            }
                        }}
                    />
                </Box>
            )}
        </Stack>
    );
};

export default ActivityItem;
